import { createFooter, initDictionaryCatalog } from '@wg/wows-common-footer/main';
import { IFooterProps, Realm } from '@wg/wows-common-footer/types';
import { useEffect } from 'react';

import preloaded from '~/preloaded';

import styles from './Footer.scss';

const Footer = () => {
  useEffect(() => {
    async function initFooter() {
      await initDictionaryCatalog({
        language: preloaded.settings.languageCode,
        dictionaryCatalog: window.i18n.catalog,
      });

      const options: IFooterProps = {
        selector: '#footer-container',
        language: preloaded.settings.languageCode,
        realm: preloaded.settings.realm as Realm,
        version: '',
        dictionaryCatalog: window.i18n.catalog,
        rootUrl: null,
        onLanguageChange: ({ realm, language }) => {
          location.href = `${preloaded.settings.realmsMap[realm]}/?lang=${language}`;
        },
        onClickByLink: (event: MouseEvent) => {
          event.preventDefault();
          const target = event.currentTarget as HTMLLinkElement;
          if (target.id !== 'ot-sdk-btn') {
            window.open(target.href, '_blank');
          }
        },
      };

      if (preloaded.settings.realm === 'cn360') {
        options.realms = [];
      }

      createFooter(options);

      if (window.OneTrust) {
        window.OneTrust.initializeCookiePolicyHtml();
      }
    }

    initFooter();
  }, []);

  return <div id={'footer-container'} className={styles.footer} />;
};

export default Footer;
